import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

function Actions() {
  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <Chip label="Coming Soon" color="warning" sx={{ mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        Proactive Actions
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Proactive action tracking will be available in Phase 2.
      </Typography>
    </Box>
  );
}

export default Actions;
